// Timing for the homepage showreel.
// Each clip plays for CLIP_SECONDS, then the reel cuts to the next one with a
// TRANSITION_MS fade in from black.
export const CLIP_SECONDS = 5;
export const TRANSITION_MS = 800;

// Index of the clip after `current` in a reel of `count` clips. After the last
// clip the reel wraps back to the first.
export function nextIndex(current, count) {
  if (!(count > 0)) return 0;
  return (current + 1) % count;
}
